import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { Msp } from '../types';
import { apiService } from './api.service';

class MspService {
  async getAllMsp(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP, params);
  }

  async getMspBuss(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_BUSS, params);
  }

  async getMspBreaker(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_BREAKER, params);
  }

  async getMspManufacturer(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_MANUFACTURER, params);
  }

  async getMspLocation(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_LOCATION, params);
  }

  async getMspStyle(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_STYLE, params);
  }

  async getMspType(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_TYPE, params);
  }

  async getMspCadLocation(status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP_CAD_LOCATION, params);
  }

  async getByCategory(category: string, status: string = STATUS_FILTER_VALUES.ALL): Promise<Msp[]> {
    const params = { category, [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Msp[]>(CR_API_ENDPOINTS.MSP, params);
  }

  async getMspById(id: string): Promise<Msp> {
    return apiService.get<Msp>(`${CR_API_ENDPOINTS.MSP}/${id}`);
  }

  async createMsp(mspData: {
    category: string;
    value: string;
    displayOrder?: number;
  }): Promise<Msp> {
    return apiService.post<Msp>(CR_API_ENDPOINTS.MSP, mspData);
  }
}

export const mspService = new MspService();